import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { EChannels } from 'core/model/enums';
import { useAppSelector } from 'core/store';

export const useAuth = () => {
  const isAuth = useIsAuthenticated();

  const { accounts } = useMsal();

  const [account] = accounts;

  return {
    isAuth,
    name: account?.name || '',
    username: account?.username || '',
  };
};

const getUserChannel = (roleList: Array<string>): EChannels | null => {
  const isDiaDiaUser = roleList.includes('Backoffice_DiaDia_Admin');

  if (isDiaDiaUser) {
    return EChannels.DIA_DIA;
  }

  const isInsumaUser = roleList.includes('Backoffice_Insuma_Admin');

  if (isInsumaUser) {
    return EChannels.INSUMA;
  }

  return null;
};

export const useUserRole = () => {
  const roleList = useAppSelector(state => state.userSession.role || []);

  const isDiaDiaUser = roleList.includes('Backoffice_DiaDia_Admin');

  const isInsumaUser = roleList.includes('Backoffice_Insuma_Admin');

  /**
   * A super admin is a user that has both roles (`DiaDia` and `Insuma`).
   */
  const isSuperAdmin = isDiaDiaUser && isInsumaUser;

  const channel = isSuperAdmin ? null : getUserChannel(roleList);

  return {
    isSuperAdmin,
    /**
     * A `DiaDia` user is a user that has the `DiaDia` role and is not a super admin.
     */
    isDiaDiaUser: isDiaDiaUser && !isSuperAdmin,
    /**
     * An `Insuma` user is a user that has the `Insuma` role and is not a super admin.
     */
    isInsumaUser: isInsumaUser && !isSuperAdmin,
    /**
     * The channel of the user. It will be `null` if the user is a super admin or has no channel role.
     */
    channel,
  };
};
